export default __webpack_public_path__ + "static/media/feature-2.b1ffb410.svg";